const URL = "https://hcserver.dplanit.co.kr";
// const URL = "http://localhost:8082";


export { URL };
